import { render, staticRenderFns } from "./OrderReceivable.vue?vue&type=template&id=43fcce12&"
import script from "./OrderReceivable.vue?vue&type=script&lang=js&"
export * from "./OrderReceivable.vue?vue&type=script&lang=js&"
import style0 from "./OrderReceivable.vue?vue&type=style&index=0&id=43fcce12&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports